// @core/api/endpoints/product/update_product.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ProductResponse,
  UpdateProductRequest,
} from '../../../types/product';

const BASE_PATH = '/product';

/**
 * Update product
 * Updates an existing product's metadata, branding, URLs, OAuth settings, or capabilities. Only the product owner can perform this operation.
 */
export async function UpdateProduct(
  product_id: string,
  data: UpdateProductRequest,
  options?: RequestOptions
): Promise<ProductResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/products/:product_id`;
  requestPath = requestPath.replace(':product_id', encodeURIComponent(product_id));
  const requestOptions = options;
  return client.put<ProductResponse>(requestPath, data, requestOptions);
}
